import React from 'react';
import FlameSwords from './FlameSwords';
import WaterNinja from './WaterNinja';
import NinjaGirl from './NinjaGirl';

export default class RecruitHeroes extends React.PureComponent {
    static propTypes = {};
    render() {
        return (
            <div className="recruit-heroes container-fluid">
                <div className="heroes">
                    <FlameSwords />
                    <WaterNinja />
                    <NinjaGirl />
                </div>
                <div className="content">
                    <h2>About The Game</h2>
                    <h1>Recruit Your Heroes</h1>
                    <p>Create dream teams of ninjas, mages, robots, and dinosaurs!</p>
                </div>
            </div>
        );
    }
}

